// extracted by mini-css-extract-plugin
module.exports = {"AboutUsSection":"AboutUsSection_AboutUsSection___w80m","ButtonArea":"AboutUsSection_ButtonArea__3rkLt"};